import { MagnifyingGlass } from '@phosphor-icons/react';

const UserFilterBar = ({ userTypeFilter, setUserTypeFilter, search, setSearch }) => (
  <div className="flex flex-col sm:flex-row gap-3">
    <div className="relative flex-1">
      <MagnifyingGlass size={16} weight="bold" className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search by name, email, city..."
        className="w-full bg-white border border-gray-200 focus:border-[#F97316] focus:ring-2 focus:ring-orange-100 rounded-full pl-11 pr-4 py-2.5 text-sm outline-none"
        data-testid="users-search-input"
      />
    </div>
    <select
      value={userTypeFilter}
      onChange={(e) => setUserTypeFilter(e.target.value)}
      className="bg-white border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none"
      data-testid="users-filter-select"
    >
      <option value="all">All users</option>
      <option value="player">Players only</option>
      <option value="organizer">Organizers only</option>
      <option value="admin">Admins</option>
    </select>
  </div>
);

export default UserFilterBar;
